import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  getAllPractitionersList: [],
  getPractitionerById: {},
  practitionersOrgLevel: [],
  practitionerFilter: [],
  autoGeneratePractitionerDetails: {},
  fronteggRoles: [],
  allDestinationPractitionerNamesOrgUuids: [],
  allDestinationPractitionerNamesOrgUuidsLoading: false,
  fronteggRolesCurrentOrg: [],
  fronteggRolesAll: [],
};

const doctorsSlice = createSlice({
  name: 'doctorsSlice',
  initialState,
  reducers: {
    getAllPractitionersListSlice: (state, { payload }) => {
      state.getAllPractitionersList = payload;
    },
    getPractitionerByIdSlice: (state, { payload }) => {
      state.getPractitionerById = payload;
    },
    getPractitionersOrgLevelSlice: (state, { payload }) => {
      state.practitionersOrgLevel = payload;
    },
    getPractitionerFilterSlice: (state, { payload }) => {
      state.practitionerFilter = payload;
    },
    getAutoGeneratePractitionerDetailsSlice: (state, { payload }) => {
      state.autoGeneratePractitionerDetails = payload;
    },
    getFronteggRolesSlice: (state, { payload }) => {
      state.fronteggRoles = payload;
    },
    getFronteggRolesCurrentOrgSlice: (state, { payload }) => {
      state.fronteggRolesCurrentOrg = payload;
    },
    allDestinationPractitionerNamesOrgUuidsSlice: (state, { payload }) => {
      state.allDestinationPractitionerNamesOrgUuids = payload;
    },
    allDestinationPractitionerNamesOrgUuidsLoadingSlice: (
      state,
      { payload }
    ) => {
      state.allDestinationPractitionerNamesOrgUuidsLoading = payload;
    },
    getFronteggRolesAllSlice: (state, { payload }) => {
      state.fronteggRolesAll = payload;
    },
  },
});

const { actions, reducer } = doctorsSlice;

export const {
  getAllPractitionersListSlice,
  getPractitionerByIdSlice,
  getPractitionersOrgLevelSlice,
  getPractitionerFilterSlice,
  getAutoGeneratePractitionerDetailsSlice,
  getFronteggRolesSlice,
  allDestinationPractitionerNamesOrgUuidsSlice,
  allDestinationPractitionerNamesOrgUuidsLoadingSlice,
  getFronteggRolesCurrentOrgSlice,
  getFronteggRolesAllSlice,
} = actions;

export default reducer;
